import xhr from 'xhr';
import Dropzone from 'dropzone';

let formFileUploader = null;

const formInit = (e) => {
  const formElement = document.getElementById('rrform');
  const formFields = document.querySelectorAll('input, textarea, select', formElement);
  const formUpload = document.getElementById('rrform-image-upload');

  if (formElement) {
    formElement.addEventListener('submit', formSubmit);
    if (formFields && formFields.length > 1) {
      for (const field of formFields) {
        field.addEventListener('focus', fieldUpdateHideError);
        field.addEventListener('click', fieldUpdateHideError);
        field.addEventListener('change', fieldUpdateHideError);
      }
    }
  }

  if (formUpload) {
    formFileUploader = new Dropzone("#rrform-image-upload", {
      url: "/?action=rr-image-upload",
      addRemoveLinks: true,
      uploadMuiltple: true,
      maxFiles: 4,
      parallelUploads: 1,
      success: async function(file, response) {
        file.previewElement.querySelector("img").src = response;
      },
      error: function(file, errorMessage) {
        alert(`Upload File Error:\n${errorMessage}`);
        formFileUploader.removeFile(file);
      },
    });
  }
};

async function formSubmit(e) {
  e.preventDefault();
  e.stopPropagation();

  const form = e.target;
  const button = document.querySelector('button[type=submit]', form);
  const generalError = document.querySelector('.form-general-error', form);
  const generalSuccess = document.querySelector('.form-general-success', form);
  const fieldErrors = document.querySelectorAll('.form-error', form);
  const spinner = document.querySelector('.loading');

  // Reset Form
  for (const fields of fieldErrors) {
    hideError(fields);
  }

  hideError(generalError);
  hideError(generalSuccess);
  buttonDisable(button);
  spinnerShow(spinner);

  // Serialize Form Data
  const fields = {};
  const data = new FormData(e.target);

  for (const key of data.keys()) {
    fields[key] = data.get(key);
  }

  // Image Upload
  fields.images = [];
  if (formFileUploader && formFileUploader.files && formFileUploader.files.length > 0) {
    for (const file of formFileUploader.files) {
      fields.images.push(file.previewElement.querySelector("img").src);
    }
  }

  // Submit
  xhr({
    method: "POST",
    json: fields,
    uri: "/?action=rr-contact-form",
    headers: {
      "Content-Type": "application/json",
    },
  }, (err, resp, body) => {
    if (!body.success) {
      if (body.error === "VALIDATION_ERROR") {
        for (const key of body.fields) {
          const fieldError = document.querySelector(`.form-error[data-field=${key}]`, form);
          showError(fieldError);
        }
      } else {
        showError(generalError);
      }
    } else {
      form.reset();
      if (formFileUploader) {
        formFileUploader.removeAllFiles(true);
      }
      showError(generalSuccess);
      form.scrollIntoView();
    }

    buttonEnable(button);
    spinnerHide(spinner);

    grecaptcha.reset();
  });

  return false;
};

const fieldUpdateHideError = (e) => {
  const key = e.target.getAttribute('name');
  const error = document.querySelector(`.form-error[data-field=${key}]`, e.target.parentElement);
  hideError(error);
};

const spinnerShow = (element) => {
  if (element) {
    element.setAttribute('style', 'display: flex;');
  }
};

const spinnerHide = (element) => {
  if (element) {
    element.setAttribute('style', 'display: none;');
  }
};

const buttonDisable = (element) => {
  if (element) {
    element.setAttribute('disabled', 'disabled');
  }
};

const buttonEnable = (element) => {
  if (element) {
    element.removeAttribute('disabled');
  }
};

const showError = (element) => {
  if (element) {
    element.setAttribute('style', 'display:block;');
  }
};

const hideError = (element) => {
  if (element) {
    element.setAttribute('style', '');
  }
};

export default formInit;
